








import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

const MAGIC_TEXTAREA_DEFAULT_HEIGHT = 66; //exactly 2 lines, smaller values break layout

@Component
export default class AnimatedInput extends Vue {
    @Prop(String) label!: string;
    @Prop(String) hint!: string;
    @Prop(String) placeholder!: string;
    @Prop(String) value!: string;
    @Prop(Boolean) inline!: boolean;
    @Prop(String) error!: string;
    @Prop(String) type!: string;

    focused: boolean = false;
    internalValue: string = this.value || '';

    get animationClass() {
        if (this.focused || this.internalValue !== '') {
            return 'ai-filled';
        } else {
            return '';
        }
    }

    handleEnter() {
      this.doAutoResize();
      this.$emit('enter');
    }

    handleInput() {
        this.doAutoResize();
        this.$emit('input', this.internalValue);
    }

    handleFocus() {
        this.focused = true;
        this.$emit('focus');
    }

    handleBlur() {
        this.focused = false;
        this.$emit('blur');
    }

    @Watch('internalValue')
    onValueChanged(val: string, oldVal: string) { /* The decorator does a swap new -> internal */ }

    doAutoResize() {
      const textarea = this.$refs.textarea as HTMLTextAreaElement;
      textarea.style.height = 'auto';
      textarea.style.height = (Math.max(textarea.scrollHeight, MAGIC_TEXTAREA_DEFAULT_HEIGHT)) + "px";
    }

    mounted() {
      const textarea = this.$refs.textarea as HTMLTextAreaElement;
      textarea.setAttribute("style", "height:" + (Math.max(textarea.scrollHeight, MAGIC_TEXTAREA_DEFAULT_HEIGHT)) + "px;overflow-y:hidden;");
    }
}
